import lang from 'dojo/_base/lang';
import { compose, mdsWidget } from 'dojo/_base/declare';
import topic from 'dojo/topic';

import _EntityViewMixin from '../../moreCore/UI/EntityBased/EntityView/EntityView';
import _WidgetBase from 'dijit/_WidgetBase';
class EvTaskView extends compose(_EntityViewMixin<EvTask>) {

    private _loadingRequest: dojo.request.Promise<any> = null;
    private editingVisible: boolean = false;

    private actionNode: HTMLElement;
    private contentNode: HTMLElement;
    private btnDelete: HTMLButtonElement;

    private _additionalRequestParams: Object = null;

    /**
    * 
    * @param entityId
    * @param label
    * @param additionalParams
    * @param tabContainerName
    * @param contextName Beliebiger Kontextname, der im Backend eine Differenzierung zum Zweck der Ansicht zulässt
    */


    setup(entityId: string,
        label: string,
        contextName?: string,
        tabContainerName?: string,
        additionalParams?: Object) {

        if (additionalParams) {
            this.config.additionalRequestParams = lang.clone(additionalParams);
        }

        if (contextName) this.setContextName(contextName);

        this.showAsDlg(entityId, label, tabContainerName);
    }

    onShow() {
        this.handleAdditionalButtons();
    }

    private handleAdditionalButtons() {

    }

    protected onRequestEditor(entityID: string, entity): MdsLax<InstanceType<typeof _WidgetBase>> {

        return null;
    }

    afterDelete() {
        topic.publish("PrivateAppointment/Deleted", this.entity); //TODO
    }

    private _onDeletePrivateAppointmentError(error: more.requestErrorMessage) {
        this.StandbyStop();

        alert(error.Message);
    }


    private _onEditorSaved(response) {
        this.emit("saved", response);
        this.reload();
    }

    postCreate(): void {

        this.config = {
            entityClassname: "vt_ev_task",
            labelProperty: "description",
            entityClassPrintname: "General_Label_EvTask",
            cloneOptions: {
                userroleClone: "EvTask_Clone",
            },
            //featurePathClone: "EvTask/Clone",
            editOptions: {
                userroleEdit: "EvTask_Edit",
                featurePathEdit: "EvTask/Editor",
                onChangedEventName: "change",
                onDeletedEventName: "deleted",
                onSavedEventName: "saved"
            },
            deleteOptions: {
                userroleDelete: "EvTask_Delete",
            }
            //featurePathDelete: null,
            //requestDataFunctionname:"Webtool_API_Appointments__GetEntityData"
        }
        super.postCreate.apply(this, arguments as any);


        //    this.checkPrivileges();
    }
    startup(): void {
        super.startup.apply(this, arguments as any);
    }
}

export default mdsWidget(EvTaskView);